import {
	NotificationChannelData,
	PushChannelsPerUser,
} from "@api-types/push-notifications/PushNotificationsDto";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class PushNotificationsChannelSubscriptionsApiService {
	static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/mobile-push-channel-subscriptions`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async fetchPushChannelsPerUser(
		options?: ContextOptions
	): Promise<PushChannelsPerUser> {
		const context = getApiRequestContext(options);
		return httpClient.get(
			`${this.baseUrl}/user-subscription?embed=MobilePushChannel&translate=true`,
			this.getRequestHeaders(context)
		);
	}

	static async updateUserPushChannel(
		formData: NotificationChannelData,
		options?: ContextOptions
	) {
		const context = getApiRequestContext(options);

		return httpClient.post(
			`${this.baseUrl}/user-subscription/batch?embed=MobilePushChannel`,
			JSON.stringify(formData),
			this.getRequestHeaders(context),
			{ responseType: "raw" }
		);
	}
}
